/**
 * Les nouveautés (GDD §27).
 *
 * Un fichier statique livré avec le jeu, et non une table : chaque déploiement
 * embarque naturellement son entrée, l'historique vit dans le dépôt, et il n'y a
 * ni écriture ni modération à prévoir. C'est le seul contenu du jeu dont l'auteur
 * est le développeur.
 */
export interface Nouveaute {
  date: string
  titre: string
  lignes: string[]
}

let cache: Nouveaute[] | null = null

export async function nouveautes(): Promise<Nouveaute[]> {
  if (cache) return cache
  const r = await fetch("/news.json")
  if (!r.ok) throw new Error(`Nouveautés indisponibles (${r.status})`)
  cache = (await r.json()) as Nouveaute[]
  return cache
}

const CLE_LU = "dofusidle.newsLu"

/** La dernière date déjà lue. Vide au premier passage : tout est nouveau. */
export const derniereLue = (): string => localStorage.getItem(CLE_LU) ?? ""

export const marquerLues = (n: Nouveaute[]): void => {
  if (n[0]) localStorage.setItem(CLE_LU, n[0].date)
}

/** Combien d'entrées n'ont pas encore été lues. */
export const nonLues = (n: Nouveaute[]): number => {
  const lu = derniereLue()
  // Premier passage : on n'annonce pas trois ans d'historique comme « non lu ».
  if (!lu) return n.length > 0 ? 1 : 0
  return n.filter((x) => x.date > lu).length
}
